export const SET_PRODUCT = 'setProduct';
export const SET_REFERRER = 'setReferrer';
export const SET_KEY = 'setKey';
export const SET_NO_SALES_EMAIL = 'setNoSalesEmail';
export const GET_GOOGLE_INFO = 'getGoogleInfo';
export const IS_GOOGLE_ADMIN = 'isGoogleAdmin';
export const IS_CURRENT_CUSTOMER = 'isCurrentCustomer';
export const IS_PRODUCT_ENABLED = 'isProductEnabled';
export const IS_SUPER_ADMIN = 'isSuperAdmin';
export const HAS_PRODUCT_ACCESS = 'hasProductAccess';
export const CREATE_ACCOUNT = 'createAccount';
export const CONTACT_ADMIN = 'contactAdmin';
export const GRANT_PRODUCT_ACCESS = 'grantProductAccess';
export const ENABLE_PRODUCTS = 'enableProducts';
export const ERROR_BAD_EMAIL = 'errorBadEmail';
export const CHECK_NO_AUTH = 'checkNoAuth';
export const SET_SURVEY_REFERRALS = 'setSurveyReferrals';
export const SET_SURVEY_INTERESTS = 'setSurveyInterests';
export const SUBMIT_SURVEY = 'submitSurvey';



/** WEBPACK FOOTER **
 ** ./src/_shared/actions/actionTypes.js
 **/